import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import React, { ReactNode } from 'react';

export interface AMSErrorDialogProps {
  open: boolean;
  onClose?: () => void;
  title?: string;
  content?: ReactNode;
}

const AMSErrorDialog = ({ open, onClose, title, content }: AMSErrorDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll="paper"
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      maxWidth="md"
    >
      <DialogTitle id="scroll-dialog-title">{title}</DialogTitle>
      <DialogContent dividers={true}>{content}</DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained">
          Добре
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AMSErrorDialog;
